import React, { useState, useEffect } from "react";
import API from "../../utils/API";
import Swal from "sweetalert2";
import InputMask from "react-input-mask";
import { useSearchParams, useNavigate } from "react-router-dom";

function EditUser() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const userId = searchParams.get("id");

  const [user, setUser] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone_number: "",
    role: "ADMIN",
    status: 1,
  });

  useEffect(() => {
    if (!localStorage.getItem('yc_usr_dt_ls')) {
      window.location.href = '/login';
    }

    if (userId) {
      Swal.fire({
        title: "Carregando usuário...",
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading(),
      });

      API.getUser(API.cancelToken(), userId)
        .then((res) => {
          setUser(res.data);
          Swal.close();
        })
        .catch((err) => {
          console.error(err);
          Swal.close();
          Swal.fire("Erro", "Erro ao carregar usuário", "error");
        });
    }
  }, [userId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUser((prev) => ({ ...prev, [name]: value }));
  };

    const isCreating = !userId || userId === "0";

    const handleSubmit = () => {
    if (!user.first_name.trim() || !user.last_name.trim() || !user.email.trim() || !user.phone_number.trim()) {
      Swal.fire("Erro", "Por favor, preencha todos os campos obrigatórios.", "error");
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(user.email)) {
      Swal.fire("Erro", "Por favor, insira um email válido.", "error");
      return;
    }

    if (isCreating) {
      if (!user.password || user.password.length < 8) {
        Swal.fire("Erro", "A senha deve ter pelo menos 8 caracteres.", "error");
        return;
      }
      if (!/[A-Za-z]/.test(user.password) || !/[0-9]/.test(user.password)) {
        Swal.fire("Erro", "A senha deve conter letras e números.", "error");
        return;
      }
    }
    
    Swal.fire({
      title: "Salvando alterações...",
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading(),
    });

    API.updateUser(API.cancelToken(), userId ? userId : 0, user)
      .then(() => {
        Swal.fire("Sucesso", `Usuário ${userId == 0 || userId === null ? 'criado': 'atualizado'} com sucesso!`, "success").then(() => {
          navigate("/manage/users");
        });
      })
      .catch((err) => {
        console.error(err);
        Swal.fire("Erro", "Erro ao salvar usuário", "error");
      });
  };

  return (
    <div className="flex w-full h-full pt-8 px-20 pb-24 items-center gap-8 self-stretch">
      <div className="flex w-full h-auto py-6 px-11 flex-col items-center gap-8 self-stretch bg-white rounded shadow">
        <h2 className="text-2xl font-medium mb-4">{isCreating ? "Novo Usuário" : "Editar Usuário"}</h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full">
          <div>
            <label>Nome:</label>
            <input
              type="text"
              name="first_name"
              value={user.first_name}
              onChange={handleChange}
              className="border rounded px-3 py-2 w-full"
            />
          </div>

          <div>
            <label>Sobrenome:</label>
            <input
              type="text"
              name="last_name"
              value={user.last_name}
              onChange={handleChange}
              className="border rounded px-3 py-2 w-full"
            />
          </div>

          <div>
            <label>Email:</label>
            <input
              type="email"
              name="email"
              value={user.email}
              onChange={handleChange}
              className="border rounded px-3 py-2 w-full"
            />
          </div>

          <div>
            <label>Telefone:</label>
            <InputMask
              type="text"
              mask={"(99) 99999-9999"}
              name="phone_number"
              value={user.phone_number}
              onChange={handleChange}
              className="border rounded px-3 py-2 w-full"
            />
          </div>

          {isCreating && (
            <div>
              <label>Senha:</label>
              <input
                type="password"
                name="password"
                value={user.password || ""}
                onChange={handleChange}
                placeholder="Mínimo 8 caracteres, letras e números"
                className="border rounded px-3 py-2 w-full"
              />
            </div>
          )}

          <div>
            <label>Role (Cargo):</label>
            <select
              name="role"
              value={user.role}
              onChange={handleChange}
              className="border rounded px-3 py-2 w-full"
            >
              <option value="ADMIN">ADMIN</option>
              <option value="MECANICO">MECÂNICO</option>
              <option value="COMPRADOR">COMPRADOR</option>
              <option value="RECEPCAO">RECEPÇÃO</option>
              <option value="BOSS">CHEFE DA OFICINA</option>
            </select>
          </div>

          <div>
            <label>Status:</label>
            <select
              name="status"
              value={user.status}
              onChange={handleChange}
              className="border rounded px-3 py-2 w-full"
            >
              <option value={1}>Ativo</option>
              <option value={0}>Pendente</option>
              <option value={-1}>Inativo</option>
            </select>
          </div>
        </div>

        <div className="flex justify-end w-full mt-6">
          <button
            onClick={handleSubmit}
            className="bg-green-600 text-white px-6 py-2 rounded hover:bg-green-700"
          >
            {isCreating ? "Criar Usuário" : "Salvar Alterações"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default EditUser;
